export default () => {
  const data = {
    event_name: 'click',
    button_name: 'next_extended_photo',
    page_section: 'photos_details',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
